import type { ReactNode } from "react";
import { formatKrw } from "@makit/shared";

/** 제한 배너 — 지금 이 화면이 어디까지 되는지. 콜아웃("왜 이렇게 하는지")과 다르다. */
export function LimitBanner({ icon = "!", children }: { icon?: string; children: ReactNode }) {
  return (
    <div className="limit" role="alert">
      <span className="ico" aria-hidden="true">
        {icon}
      </span>
      <span className="body">{children}</span>
    </div>
  );
}

/* ⛔ **예시 표지 `SampleBanner` 를 걷었다** (2026-10-05 사용자 지시). 콘솔에 예시 데이터가
 * 없으니 「아래 값은 화면을 세우기 위한 예시입니다」라고 밝힐 자리도 없다. 값이 없으면 그 자리를
 * 비운다(`lib/channel-spec.ts` 머리말). */

/** "여기선 아직 못 합니다" 상자. 목업의 설계 메모다.
 *
 * ⛔ **로그인 뒤 콘솔 화면에 세우지 않는다** (2026-10-04 · 10-05 사용자 지시). 아직 남은 자리는
 * 이 회차가 손대지 못한 `screens/Login.tsx` 하나다. 그 자리를 걷으면 이 컴포넌트도 걷는다.
 * `scripts/web-console-annotations.test.mjs` 가 걷은 화면에 다시 서는 것을 막는다. */
export function CantDo({ children }: { children: ReactNode }) {
  return (
    <p className="cant">
      <span className="x" aria-hidden="true">
        ✕
      </span>
      <span>{children}</span>
    </p>
  );
}

/* ⛔ 설계 메모 상자 `Callout` 도 걷었다 (2026-10-05). 마지막으로 쓰던 `screens/Export.tsx` 의
 * 「한 장으로 이어붙이지 않습니다」 상자가 빠져 쓰는 곳이 없다. */

/** 편집 패널 맨 위 — 바꿀 수 있는 것이 넷임을 먼저 말한다. */
export function ScopeBanner({ children }: { children: ReactNode }) {
  return <span className="scope">{children}</span>;
}

/** 금액 줄 — 버튼 안이 아니라 버튼 바로 위 한 줄.
 *
 * **`amount` 는 숫자이거나 문자열이다.** 문자열을 받는 이유는 `W-31` 의 **`없음`** 때문이다
 * (PRD `7.6.13f` — 선불로 이미 냈으므로 더 낼 것이 없다). ⛔ **그 자리를 `0` 으로 적지
 * 마라** — `₩0` 은 **값이 0원인 판**으로 읽히고, 여기서 말하려는 것은 **이번에 나갈 돈이
 * 없다**는 다른 사실이다. */
export function PayNow({ label, amount }: { label: string; amount: number | string }) {
  return (
    <div className="paynow">
      <span>{label}</span>
      <span className="amt mono">{typeof amount === "number" ? formatKrw(amount) : amount}</span>
    </div>
  );
}
